<template>
	<div class="search-jsj-tatle">
		<div style="display: flex;">
			<el-button style="margin: 0 10px;" type="primary" plain icon="Search" @click="centerDialogVisible = true">高级搜索</el-button>
			<el-input
			  v-model="searchVal"
			  placeholder="请输入订单号"
			  class="input-with-select"
			>
			  <template #append>
			    <el-button @click="fetchOrders" icon="Search" />
			  </template>
			</el-input>
		</div>
	</div>
	<el-table :data="tableData" style="width: 100%" height="720">
	    <el-table-column fixed prop="order_id" label="订单号" width="120" />
	    <el-table-column prop="ydsj" label="预订时间" width="160" />
		<el-table-column prop="cfd" label="出发地" width="320" />
		<el-table-column prop="mdd" label="目的地" width="320" />
	    <el-table-column prop="hbh" label="航班号" width="120" />
		<el-table-column prop="jc" label="机场" width="120" />
		<el-table-column prop="ckcx" label="人数/行李/车型" width="150" />
		<el-table-column prop="spdesc" label="客户需求" width="260" />
		<!-- <el-table-column prop="zfje" label="支付金额" width="120" /> -->
	    <el-table-column prop="status" label="状态" width="120" />
		<el-table-column prop="src" label="来源" width="120" />
		<el-table-column prop="memo" label="备注" width="200" />
	    <el-table-column fixed="right" label="操作" width="140">
	      <template #default="scope">
			<el-button link type="primary" size="small" @click="detailClick(scope.row)">详情</el-button>
			<el-button link v-if="scope.row.status==='已确认'" type="primary" size="small" @click="addBzClick(scope.row)">备注</el-button>
			<el-button link v-if="scope.row.status==='已确认'" type="primary" size="small" @click="assignDriverClick(scope.row)">派单</el-button>
			<!-- <el-button link v-if="scope.row.status==='confirmed'" type="primary" size="small" @click="assignDriver(scope.row)">指派司机</el-button> -->
	      </template>
	    </el-table-column>
	</el-table>
	<div class="pagination-custom">
		<el-pagination :page-size="20" @current-change="changePageNo" background layout="pager" :total="total" />
	</div>
	<el-dialog
	    v-model="bzDialogVisible"
	    title="添加备注"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>
		<el-input class="w-50 m-2" v-model="newBz" />
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="bzDialogVisible = false">关闭</el-button>
		    <el-button type="primary" @click="saveBz">保存</el-button>
		  </span>
		</template>
	</el-dialog>
	<el-dialog
	    v-model="pdDialogVisible"
	    :title="'派单信息:' + order_id + '  预约时间:' + ydsj + '  行程:' + trip"
	    fullscreen
		show-close
	>
		<template #header>
			派单信息: <span class="dialog-title">{{order_id}}</span> 
			预约时间:<span class="dialog-title-car">{{ydsj}}</span> 
			行程:<span class="dialog-title">{{trip}}</span> 
			人数/行李/车型:<span class="dialog-title-car">6/0/经9</span>
		</template>
		<ResourceCalendar />
		<template #footer>
			<el-table :data="dayTableData" style="width: 100%" height="420" @row-click="rowClick">
			    <el-table-column fixed prop="order_id" label="订单号" width="120" />
			    <el-table-column prop="ydsj" label="预订时间" width="160" />
				<el-table-column prop="cfd" label="出发地" width="320" />
				<el-table-column prop="mdd" label="目的地" width="320" />
			    <el-table-column prop="hbh" label="航班号" width="120" />
				<el-table-column prop="jc" label="机场" width="120" />
				<el-table-column prop="ckcx" label="人数/行李/车型" width="150" />
				<el-table-column prop="spdesc" label="客户需求" width="260" />
			    <el-table-column prop="status" label="状态" width="120" />
				<el-table-column prop="src" label="来源" width="120" />
				<el-table-column prop="memo" label="备注" width="200" />
			</el-table>
		</template>
	</el-dialog>
	<el-dialog
	    v-model="centerDialogVisible"
	    title="高级搜索"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>
		<div>
			<h4>
				按下单时间
			</h4>
			<div class="dialog-cond-dt">
				<label class="dialog-cond-label">开始时间:</label>
				<el-date-picker
					v-model="xdkssj"
					type="datetime"
					placeholder="选择开始日期和时间"
					:shortcuts="shortcuts0"
					format="YYYY-MM-DD HH:mm:ss"
					:default-time="defaultTime0(0)"
					value-format="YYYY-MM-DD HH:mm:ss"
				/>
				<label class="dialog-cond-label">结束时间:</label>
				<el-date-picker
					v-model="xdjssj"
					type="datetime"
					placeholder="选择结束日期和时间"
					:shortcuts="shortcuts1"
					format="YYYY-MM-DD HH:mm:ss"
					:default-time="defaultTime1(23)"
					value-format="YYYY-MM-DD HH:mm:ss"
				/>
			</div>
		</div>
	    <div>
	    	<h4>
	    		按使用时间
	    	</h4>
	    	<div class="dialog-cond-dt">
	    		<label class="dialog-cond-label">开始时间:</label>
	    		<el-date-picker
	    			v-model="sykssj"
	    			type="datetime"
	    			placeholder="选择开始日期和时间"
	    			:shortcuts="shortcuts0"
					format="YYYY-MM-DD HH:mm:ss"
					:default-time="defaultTime0(0)"
					value-format="YYYY-MM-DD HH:mm:ss"
	    		/>
	    		<label class="dialog-cond-label">结束时间:</label>
	    		<el-date-picker
	    			v-model="syjssj"
	    			type="datetime"
	    			placeholder="选择结束日期和时间"
	    			:shortcuts="shortcuts1"
					format="YYYY-MM-DD HH:mm:ss"
					:default-time="defaultTime1(23)"
					value-format="YYYY-MM-DD HH:mm:ss"
	    		/>
	    	</div>
	    </div>
		<div>
			<h4>
				按订单状态
			</h4>
			<div class="dialog-cond-dt" style="width: 480px;display: flex;">
				<el-checkbox
					v-model="checkAllZt"
					:indeterminate="isIndeterminateZt"
					@change="handleCheckAllChangeZt"
				  >
					全选
				  </el-checkbox>&nbsp;&nbsp;
				  <el-checkbox-group
					v-model="checkedCitiesZt"
					@change="handleCheckedCitiesChangeZt"
				  >
					<el-checkbox v-for="city in citiesZt" :key="city" :label="city" :value="city">
					  {{ city }}
					</el-checkbox>
				  </el-checkbox-group>
			</div>
		</div>
		<div>
			<h4>
				按订单号
			</h4>
			<div class="dialog-cond-dt" style="width: 320px;display: flex;">
				<label class="dialog-cond-label" style="width: 60px;">订单号:</label>
				<el-input v-model="ddbh" :clearable="true" class="w-50 m-2" placeholder="请输入完整的订单号" />
			</div>
		</div>
		<div>
			<h4>
				按订单来源
			</h4>
			<div class="dialog-cond-dt" style="width: 480px;display: flex;">
				<el-checkbox
				    v-model="checkAll"
				    :indeterminate="isIndeterminate"
				    @change="handleCheckAllChange"
				  >
				    全选
				  </el-checkbox>&nbsp;&nbsp;
				  <el-checkbox-group
				    v-model="checkedCities"
				    @change="handleCheckedCitiesChange"
				  >
				    <el-checkbox v-for="city in cities" :key="city" :label="city" :value="city">
				      {{ city }}
				    </el-checkbox>
				  </el-checkbox-group>
			</div>
		</div>
		
	    <template #footer>
	      <span class="dialog-footer">
	        <el-button @click="centerDialogVisible = false">取消</el-button>
	        <el-button type="primary" @click="highSearchOrders">搜索</el-button>
	      </span>
	    </template>
	</el-dialog>
	<el-dialog
		@close="closeDtDialog"
	    v-model="jsjDialogVisible"
	    title="接送机服务"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>
		<DataForm />
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="closeDtDialog">关闭</el-button>
		  </span>
		</template>
	</el-dialog>
	<el-dialog
		@close="closeDtDialog1"
	    v-model="jsjDialogVisible1"
	    title="订单详情"
	    width="50%"
	    destroy-on-close
		:modal="false"
	>
		<DataForm1 />
		<template #footer>
		  <span class="dialog-footer">
		    <el-button @click="closeDtDialog1">关闭</el-button>
		  </span>
		</template>
	</el-dialog>
</template>

<script setup>
	import { ref,provide,onMounted } from 'vue';
	import ResourceCalendar from '@/components/ResourceCalendar.vue'
	import axios from 'axios';
	import DataForm from '../jsj/JsjDataForm.vue';
	import DataForm1 from '../klook/ordersInfo.vue';
	import { useMemberStore } from '../../stores';
	import { ElMessage,ElLoading  } from 'element-plus'
	const userStore = useMemberStore();
	const pdDialogVisible = ref(false)
	const jsjDialogVisible1 = ref(false)
	const closeDtDialog1=()=>{
		jsjDialogVisible1.value = false;
	}
	const jsjDialogVisible = ref(false)
	const closeDtDialog=()=>{
		jsjDialogVisible.value = false;
	}
	const detailClick=(e)=>{
		if(e.id){
			billid.value = e.id
			jsjDialogVisible1.value = true;
		}else{
			billid.value = e.order_id
			jsjDialogVisible.value = true;
		}
	}
	const assignDriverClick = (e) =>{
		if(e.id){
			billid.value = e.id
		}else{
			billid.value = e.order_id
		}
		src.value = e.src
		order_id.value = e.order_id
		ydsj.value = e.ydsj
		trip.value = e.cfd + '-->' + e.mdd
		ckcx.value = e.ckcx
		pdDialogVisible.value = true
	}
	const pageNo = ref(1);
	const pageSize = ref(20);
	const total = ref(0);
	const tableData = ref([])
	const searchVal = ref('')
	onMounted(async()=>{
		const response = await axios.post('/orders/info/queryList', {
		  pageNo:pageNo.value,
		  pageSize:pageSize.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = response.data.data;
			total.value = response.data.total;
		}
	})
	const fetchOrders = async () => {
		const response = await axios.post('/orders/info/queryList', {
		  value: searchVal.value,
		  key:'order_id',
		  pageNo:pageNo.value,
		  pageSize:pageSize.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			tableData.value = response.data.data;
			total.value = response.data.total;
		}
	};
	const billid = ref('')
	const order_id = ref('')
	const src = ref('')
	const ydsj = ref('')
	const trip = ref('')
	provide("billid",billid)
	provide("order_id",order_id)
	provide("src",src)
	provide("ydsj",ydsj)
	provide('forbidEdit', false);
	const orderForm = ref({})
	provide('orderForm', orderForm);
	const ckcx = ref('')
	const dayTableData = ref([])
	provide("dayTableData",dayTableData)
	const rowClick=(row,column,event)=>{
		if(row.id){
			billid.value = row.id
		}else{
			billid.value = row.order_id
		}
		order_id.value = row.order_id
		ydsj.value = row.ydsj
		src.value = row.src
		trip.value = row.cfd + '-->' + row.mdd
		ckcx.value = row.ckcx
	}
	
	//备注功能
	const bzDialogVisible = ref(false)
	const newBz = ref('')
	const addBzClick=(e)=>{
		if(e.id){
			billid.value = e.id
		}else{
			billid.value = e.order_id
		}
		src.value = e.src
		bzDialogVisible.value = true;
	}
	const saveBz=async()=>{
		const response = await axios.post('/orders/info/saveBz', {
		  billid:billid.value,
		  src:src.value,
		  bz:newBz.value
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage({
				message: '信息保存成功!',
				type: 'success',
			})
		}else{
			ElMessage.error('哦,信息保存失败!')
		}
		tableData.value.map(item=>{
			if((item.src==='后台录入'&&item.order_id===billid.value)){
				item.memo = newBz.value;
			}else if(item.id===billid.value){
				item.memo = newBz.value;
			}
		})
		bzDialogVisible.value = false;
	}
	//指派司机
	const assignDialogVisible = ref(false)
	const sjddclDatas = ref([]);
	const sjddSjDatas = ref([]);
	const sizeForm = ref({
		driver:null,
		vehicle:null
	})
	const sjddForm = ref({
		sjddcl:'',
		xm:'',
	})
	const assignDriver = async(e)=>{
		assignDialogVisible.value = true;
		if(e.src==='小程序'||e.src==='Klook'){
			billid.value = e.id //数据ID
		}else{
			billid.value = e.order_id
		}
		src.value = e.src //数据来源
		//查询司机、车辆信息
		const respDriver = await axios.get('/klook/driver/getSelectList',{
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(respDriver.data.status===0){
			sjddSjDatas.value = respDriver.data.data;
		}
		const respVehicle = await axios.get('/klook/car/getSelectList',{
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(respVehicle.data.status===0){
			sjddclDatas.value = respVehicle.data.data;
		}
	}
	const saveAssign = async()=>{
		if(!sjddForm.value.xm||!sjddForm.value.sjddcl){
			return ElMessage.error('请选择司机、车辆后保存!')
		}
		const respDriver = await axios.post('/orders/info/assignDriver',{
			billid:billid.value,
			src:src.value,
			driver_id:sjddForm.value.xm,
			vehicle_id:sjddForm.value.sjddcl
		},{
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(respDriver.data.status===0){
			ElMessage({
				message: '司机分配成功!',
				type: 'success',
			})
		}else{
			ElMessage.error('哦,司机分配失败了!')
		}
		assignDriverDialog();
	}
	const assignDriverDialog = ()=>{
		assignDialogVisible.value = false;
	}
	const changePageNo = (val) => {
		pageNo.value = val;
		fetchOrders();
	}
	//高级搜索确认按钮
	const highSearchOrders=async()=>{
		const loading = ElLoading.service({
			lock: true,
			text: '数据查询中，请稍后',
			background: 'rgba(0, 0, 0, 0.7)'
		})
		centerDialogVisible.value = false
		const response = await axios.post('/orders/info/queryHighsearch', {
		  syjssj:syjssj.value,
		  sykssj:sykssj.value,
		  xdkssj:xdkssj.value,
		  xdjssj:xdjssj.value,
		  ddbh:ddbh.value,
		  origin:checkedCities.value.toString(),
		  ddzt:checkedCitiesZt.value.toString(),
		  pageNo:pageNo.value,
		  pageSize:pageSize.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		loading.close()
		if(response.data.status===0){
			tableData.value = response.data.data;
			total.value = response.data.total;
		}
	}
	const centerDialogVisible = ref(false);//高级搜索
	//订单来源开始
	const checkAll = ref(true)
	const isIndeterminate = ref(true)
	const checkedCities = ref(['小程序', '后台录入', 'Klook'])
	const cities = ['小程序', '后台录入', 'Klook']
	
	const handleCheckAllChange = (val) => {
	  checkedCities.value = val ? cities : []
	  isIndeterminate.value = false
	}
	const handleCheckedCitiesChange = (value) => {
	  const checkedCount = value.length
	  checkAll.value = checkedCount === cities.length
	  isIndeterminate.value = checkedCount > 0 && checkedCount < cities.length
	}
	//订单来源结束
	//订单状态开始
	const checkAllZt = ref(true)
	const isIndeterminateZt = ref(true)
	const checkedCitiesZt = ref(['已确认', '已取消'])
	const citiesZt = ['已确认', '已取消']
	
	const handleCheckAllChangeZt = (val) => {
	  checkedCitiesZt.value = val ? citiesZt : []
	  isIndeterminateZt.value = false
	}
	const handleCheckedCitiesChangeZt = (value) => {
	  const checkedCount = value.length
	  checkAllZt.value = checkedCount === citiesZt.length
	  isIndeterminateZt.value = checkedCount > 0 && checkedCount < citiesZt.length
	}
	//订单状态结束
	const ddbh = ref('');
	const syjssj = ref('');
	const sykssj = ref('');
	const xdkssj = ref('');
	const xdjssj = ref('');
	const defaultTime0 = (a) => {
		var now = new Date(); // 获取当前日期和时间
		now.setHours(a); // 设置小时为8（24小时制）
		now.setMinutes(0);
		now.setSeconds(0);
		return now
	}
	const defaultTime1 = (a) => {
		var now = new Date(); // 获取当前日期和时间
		now.setHours(a); // 设置小时为8（24小时制）
		now.setMinutes(59);
		now.setSeconds(59);
		return now
	}
	const formatDateTime0 = (date)=>{
		function padZero(num) {
			return num < 10 ? '0' + num : num;
		}
		const year = date.getFullYear();
		const month = padZero(date.getMonth() + 1);
		const day = padZero(date.getDate());
		return `${year}-${month}-${day} 00:00:00`;
	}
	const formatDateTime = (date)=>{
		function padZero(num) {
			return num < 10 ? '0' + num : num;
		}
		const year = date.getFullYear();
		const month = padZero(date.getMonth() + 1);
		const day = padZero(date.getDate());
		return `${year}-${month}-${day} 23:59:59`;
	}
	const shortcuts0 = [
	  {
	    text: '一周前',
	    value: () => {
	      const date = new Date()
	      date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
	      return formatDateTime0(date);
	    },
	  },{
	    text: '昨　天',
	    value: () => {
	      const date = new Date()
	      date.setTime(date.getTime() - 3600 * 1000 * 24)
	      return formatDateTime0(date);
	    },
	  },{
	    text: '今　天',
	    value: ()=>{
			return formatDateTime0(new Date());
		}
	  },{
	    text: '明　天',
	    value: () => {
	      const date = new Date()
	      date.setTime(date.getTime() + 3600 * 1000 * 24)
	      return formatDateTime0(date);
	    },
	  },{
	    text: '一周后',
	    value: () => {
	      const date = new Date()
	      date.setTime(date.getTime() + 3600 * 1000 * 24 * 7)
	      return formatDateTime0(date);
	    },
	  },
	  
	]
	const shortcuts1 = [
	  {
	    text: '一周前',
	    value: () => {
	      const date = new Date()
	      date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
	      return formatDateTime(date);
	    },
	  },{
	    text: '昨　天',
	    value: () => {
	      const date = new Date()
	      date.setTime(date.getTime() - 3600 * 1000 * 24)
	      return formatDateTime(date);
	    },
	  },{
	    text: '今　天',
	    value: ()=>{
			return formatDateTime(new Date());
		}
	  },{
	    text: '明　天',
	    value: () => {
	      const date = new Date()
	      date.setTime(date.getTime() + 3600 * 1000 * 24)
	      return formatDateTime(date);
	    },
	  },{
	    text: '一周后',
	    value: () => {
	      const date = new Date()
	      date.setTime(date.getTime() + 3600 * 1000 * 24 * 7)
	      return formatDateTime(date);
	    },
	  },
	  
	]
</script>

<style scoped>
	.pagination-custom{
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin: 10px 0;
	}
	.search-jsj-tatle{
		float: right;
		width: 50%;
		margin: 0 0 10px 0;
	}
	.dialog-cond-dt{
		margin: 0 0 0 20px;
	}
	.dialog-cond-label{
		margin: 0 5px;
	}
	.dialog-title{
		color: #409eff;
		font-size: 18px;
		font-weight: 600;
	}
	.dialog-title-car{
		color: red;
		font-size: 18px;
		font-weight: 600;
	}
</style>